import { getDefaultClient } from '../../../client/defaultClient';
import type { WalletAccount } from '../../wallets/walletAccount';
import { getWaasWalletProviderFromWalletAccount } from '../getWaasWalletProviderFromWalletAccount';

type ExportWaasPrivateKeyParams = {
  displayContainer: HTMLElement;
  password?: string;
  walletAccount: WalletAccount;
};

/**
 * Exports the private key for a WaaS wallet account with secure display.
 *
 * This function reveals the private key for a WaaS wallet and displays it
 * securely within an iframe dynamically inserted into the specified HTML container element.
 *
 * @param params.walletAccount - The WaaS wallet account to export the private key from.
 * @param params.displayContainer - The HTML element where the iframe will be injected.
 * @param [params.password] - Optional password to decrypt the private key.
 * @param [client] - The Dynamic client instance. Only required when using multiple Dynamic clients.
 * @returns A promise that resolves when the private key export is complete.
 */
export const exportWaasPrivateKey = async (
  { displayContainer, password, walletAccount }: ExportWaasPrivateKeyParams,
  client = getDefaultClient()
) => {
  const provider = getWaasWalletProviderFromWalletAccount(
    { walletAccount },
    client
  );

  return provider.exportPrivateKey({
    displayContainer,
    password,
    walletAccount,
  });
};
